import React, {useState} from 'react';
import Linkpages from "./Linkpages";
// import '../css/vagadent.css';
import '../css/contact.css';
import '../css/media.css';
import {useTranslation} from "react-i18next";
import mobile from '../images/mobile.png';
import address from '../images/address.png';
import Vagadent_Qr from '../images/Vagadent_Qr.png';

function Contact(props) {

    const {t, i18n} = useTranslation("common");
    const [menuOpen, setMenuOpen] = useState(false); // 2. Մոբայլ մենյուի վիճակը


    const handleClick = () => {
        const googleMapsUrl="https://www.google.com/maps/place/11+Lepsius+St,+Yerevan+0035/@40.2084901,44.5445986,17.71z/data=!4m6!3m5!1s0x406aa2da1656b4ef:0x47dd1b9b0d6f3e46!8m2!3d40.2087592!4d44.5461193!16s%2Fg%2F11c4skrs9t?entry=ttu&g_ep=EgoyMDI2MDQyOS4wIKXMDSoASAFQAw%3D%3D"
        window.open(googleMapsUrl,'_blank');
    }


    return (
        <div className="home-wrapper">
            <div className="header-container">
                <div className="logo-group">
                    <div className="logo"></div>
                    <div className="brand-text">
                        <div className="vagadent">{t('welcome.title')}</div>
                        <div className="dental">{t('welcome.title1')}</div>
                    </div>
                </div>

                {/* Մոբայլի ժամանակ դասը փոխվում է 'open' */}
                <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
                    <Linkpages />
                </div>

                <div className="leng">
                    <button onClick={()=>i18n.changeLanguage('hay')}>ՀԱՅ</button>
                    <button onClick={()=>i18n.changeLanguage('ru')}>РУ</button>
                    <button onClick={()=>i18n.changeLanguage('en')}>ENG</button>
                </div>
                {/* Մոբայլի բուրգեր կոճակը (Dots) */}
                <div className={`menu-dots ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

            </div>


            <div className="contact">
                <div className="hasce">
                    <div className="mobile">
                        <img src={mobile} alt=""/>
                        <span>+374 91 01 07 06</span>
                    </div>

                    <div className="address" onClick={() =>handleClick("address")}>
                        <img src={address} alt=""/>
                        <span>{t('contact.address_text')}</span>
                    </div>

                    {/* 2. ԱՎԵԼԱՑՎԱԾ Է ՄԻԱՅՆ ՁԵՐ QR ԿՈԴԻ ՆԿԱՐԻ ՑՈՒՑԱԴՐՈՒՄԸ */}
                    <img src={Vagadent_Qr} alt="QR" className="qr-image" />

                </div>
                <div className="qartez">
                    <iframe title="Google Map"
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3047.025752219771!2d44.5445986!3d40.2084901!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406aa2da1656b4ef%3A0x47dd1b9b0d6f3e46!2s11%20Lepsius%20St%2C%20Yerevan%200035!5e0!3m2!1sru!2sam!4v1778953560163!5m2!1sru!2sam"
                        width="100%" height="80%" style={{border:"0"}} allowFullScreen="" loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade">

                    </iframe>
                </div>
            </div>

        </div>
    );
}
export default Contact;